import { SNSSignIn } from '~/components/SignIn';
import { HelmetHead } from '~/components/common';
import { PAGE_ROUTE } from '~/constants';
import Background from '~/assets/img/login/login_background.jpg';
import Logo from '~/assets/img/login/login_logo.png';
import * as S from './index.styled';

export default function LoginHome() {
  return (
    <>
      <HelmetHead title='signin' />

      <S.Container>
        <S.Background>
          <img src={Background} alt='login_background' />
        </S.Background>
        <S.LoginWrapper>
          <S.Logo>
            <img src={Logo} alt='login_logo' />
            <p>Enjoy AI companion with your friends</p>
          </S.Logo>

          <SNSSignIn />
          <S.EmailLogin to={PAGE_ROUTE.SIGNIN}>
            <span>Continue with Email</span>
          </S.EmailLogin>
        </S.LoginWrapper>
      </S.Container>
    </>
  );
}
